import React, {useEffect, useState} from 'react';
import styles from './ImageWithBlurhash.module.css'
import {Blurhash} from "react-blurhash";
import clsx from "clsx";
import {isCached} from "../../../../utils/functions/isCached";

type IProps = {
    width: number | 'none'
    height: number | 'none'
    src: string
    hash: string
    classNameBlurHash?: string
}
const ImageWithBlurHash = (props: IProps) => {

    const [isCachedImage, setCachedImage] = useState<boolean>(false)

    useEffect(() => {
        setCachedImage(isCached(props.src))
    }, [props.src])

    const [isLoadImage, setIsLoadImage] = useState<boolean>(false)

    return (
        <div className={styles.wrapper}>
            {!isCachedImage && <>
                <Blurhash
                    className={clsx(props.classNameBlurHash && props.classNameBlurHash, styles.blurHash__hide)}
                    hash={props.hash}
                    width={props.width}
                    height={props.height}
                    resolutionX={32}
                    resolutionY={32}
                    punch={1}
                />
                <img onLoad={() => setIsLoadImage(true)} className={clsx(
                    styles.image,
                    props.classNameBlurHash,
                    isLoadImage && styles.image__loaded
                )} src={props.src} alt=""/>
            </>}
            {isCachedImage &&  <img className={clsx(
                props.classNameBlurHash,
            )} src={props.src} alt=""/>}


        </div>
    );
};

export default ImageWithBlurHash;